import React, { use, useEffect, useState } from 'react'
import Box from '../Box'
import { useQuery } from '@apollo/client'
import { GET_REPORTS_BY_USER } from '../../../graphql/Catalog/Reports/reports'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import LayoutTable from '../LayoutTable'
import ProgressBarStatusReport from '../ProgressBarStatusReport'
import { Link } from 'react-router-dom'
import ReportsChanel from '../../Admin/Catalogs/Reports/components/ReportsChanel'

const ReportsByUser = ({ userId, userInfo }) => {
  const [dataTable, setDataTable] = useState([])
  const [total, setTotal] = useState(0)
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })

  const { loading, data, error } = useQuery(GET_REPORTS_BY_USER, {
    variables: {
      limit: pagePagination.limit,
      offset: pagePagination.offset,
      userId: +userId,
    },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    try {
      if (!userId) return
      if (loading) return
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      const dataReports = data.getReportsByUserId.rows.map((item) => {
        const formJson = item.data_form_json
          ? JSON.parse(item.data_form_json)
          : null
        return {
          id: item.id,
          folio: item.folio,
          'Tipo/Canal': (
            <>
              <ReportsChanel
                category_name={item?.ReportToGroupCategory?.name}
                img={item?.ReportToGroupCategory?.icon}
                channel_capture={item?.channel_capture}
                sub_category_name={item?.ReportToGroupCategorySub?.name}
                img_sub_category={item?.ReportToGroupCategorySub?.icon}
              />
            </>
          ),
          estado: (
            <ProgressBarStatusReport statusReport={item?.StatusOfReport} />
            // <ProgressBarStatusReport statusReport={item.StatusOfReport.name} />
          ),
          descripción: formJson?.Descripción || 'Sin descripción',
          Acciones: (
            <Link
              type="button"
              className="btn btn-migrates btn-migrates-cover btn-sm mb-1"
              to={`/reports/details/${item.id}/show`}
              target="_blank"
              rel="noreferrer"
              title="Ver detalles de reporte"
            >
              <i class="far fa-eye"></i>
            </Link>
          ),
        }
      })

      setDataTable(dataReports)
      setTotal(data.getReportsByUserId.count)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [data, loading, error])

  return (
    <>
      <Box
        title="Reportes por usuario"
        withCard={false}
        content={
          <>
            {userInfo && (
              <div
                className="col-12 row pl-5 pt-2"
                style={{
                  borderBottom: '1px solid #e9ecef',
                  paddingBottom: 10,
                }}
              >
                <div className="col-lg-12 d-flex align-items-center">
                  <img
                    src={userInfo.avatarUrl}
                    alt="profile"
                    style={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '80%',
                    }}
                  />
                  <div
                    className="d-flex flex-column"
                    style={{
                      fontSize: 14,
                      fontWeight: 'bold',
                    }}
                  >
                    <span>
                      {' '}
                      &nbsp; &nbsp;Nombre: {userInfo && userInfo.name}
                    </span>
                    <span>
                      {' '}
                      &nbsp; &nbsp;Correo: {userInfo && userInfo.email}
                    </span>
                    <span>
                      &nbsp; &nbsp;Teléfono: {userInfo && userInfo.phone}
                    </span>
                  </div>
                </div>
              </div>
            )}

            <LayoutTable
              withCard={false}
              data={dataTable}
              totalCount={total}
              pagePagination={pagePagination}
              setPagePagination={setPagePagination}
              hideAddNew
              exportImportButton={false}
              loadingData={loading}
              hideId
              hideActions
              // onRowClicked={(row) => {
              //   // window.location.href = `/reports/details/${row.id}/show`
              //   window.open(
              //     `/reports/details/${row.id}/show`,
              //     '_blank',
              //     'noopener,noreferrer'
              //   )
              // }}
            />
          </>
        }
      />
    </>
  )
}

export default ReportsByUser
